module.exports = __webpack_public_path__ + "static/img/img-features-feature-6-i-pad@2x.4362ec2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-6-i-pad@2x.png
// module id = qcig
// module chunks = 18